<template>
  <FlexCol class="border rounded-lg w-36 h-24 max-h-24 overflow-hidden">
    <Flex center class="grow overflow-y-hidden">
      <img :src="part.cover" v-if="part.cover" class="h-full w-full object-contain" />
      <span v-else class="uppercase font-semibold text-2xl text-gray-400"> {{ part.name.slice(0, 2) }}</span>
    </Flex>
    <div class="text-sm text-center text-primary-700 uppercase bg-primary-100">
      {{ part.name }}
    </div>
  </FlexCol>
</template>

<script setup>
  const props = defineProps({
    part: Object,
  })
</script>
